var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { useTranslate } from 'ra-core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
export const ApplicationStatus = (_a) => {
    var { record, variant = 'caption' } = _a, rest = __rest(_a, ["record", "variant"]);
    const classes = useStyles(rest);
    const translate = useTranslate();
    if (!record) {
        return null;
    }
    return (React.createElement("div", { className: classnames(classes.root, {
            [classes.enabled]: record.status === 'ENABLED',
            [classes.rejected]: record.status === 'REJECTED',
            [classes.disabled]: record.status !== 'ENABLED' && record.status !== 'REJECTED',
        }) },
        React.createElement("div", { className: classes.enabledIcon }),
        record.status && (React.createElement(Typography, { className: classes.status, variant: variant }, translate(`resources.applications.status.${record.status.toLowerCase()}`)))));
};
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: 'auto',
    },
    enabled: {
        color: theme.palette.success.main,
        '& $enabledIcon': {
            backgroundColor: theme.palette.success.main,
        },
    },
    rejected: {
        color: theme.palette.error.main,
        '& $enabledIcon': {
            backgroundColor: theme.palette.error.main,
        },
    },
    disabled: {
        color: theme.palette.text.disabled,
        '& $enabledIcon': {
            backgroundColor: theme.palette.text.disabled,
        },
    },
    enabledIcon: {
        width: theme.spacing(1.5),
        height: theme.spacing(1.5),
        borderRadius: 99999,
        marginRight: theme.spacing(),
    },
    status: {},
}), {
    name: 'Layer7ApplicationStatus',
});
//# sourceMappingURL=ApplicationStatus.js.map